"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const pattern_library_components_modal_1 = require("@saatva-bits/pattern-library.components.modal/");
const utils_1 = require("../../utils");
// TODO: add other prismic defined values to the bannerConfig (slot, theme, icon)
const promotions_configs_1 = require("../../../../promotions.configs");
const BannerAction_module_scss_1 = __importDefault(require("./BannerAction.module.scss"));
const BannerAction = ({ action, actionText, theme, actionTextClassName, sitewidePromo }) => {
    const [isPanelOpen, setIsPanelOpen] = (0, react_1.useState)(false);
    const actionTextClasses = (0, classnames_1.default)(BannerAction_module_scss_1.default.actionText, {
        [BannerAction_module_scss_1.default[theme]]: !!theme
    }, actionTextClassName);
    if (action === promotions_configs_1.actions.mattressPLP) {
        return (0, jsx_runtime_1.jsx)("a", { className: actionTextClasses, href: "/mattresses", dangerouslySetInnerHTML: { __html: actionText } });
    }
    const actionConfig = (0, utils_1.getActionConfig)(action, sitewidePromo, theme);
    if (!actionConfig || !actionText) {
        return null;
    }
    const { Content, props, inPanel, panelClassName } = actionConfig;
    const modalClasses = (0, classnames_1.default)({
        [BannerAction_module_scss_1.default.modal]: !inPanel,
        [BannerAction_module_scss_1.default[`panel--${theme}`]]: inPanel,
        [BannerAction_module_scss_1.default.bmsmPanel]: panelClassName === 'bmsmPanel'
    });
    const closeButtonClass = (0, classnames_1.default)({
        [BannerAction_module_scss_1.default.panelCloseBtn]: inPanel,
        [BannerAction_module_scss_1.default[`panelCloseBtn--${theme}`]]: inPanel
    });
    const togglePanel = () => {
        setIsPanelOpen(!isPanelOpen);
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("button", { className: actionTextClasses, onClick: () => togglePanel(), dangerouslySetInnerHTML: { __html: actionText } }), (0, jsx_runtime_1.jsx)(pattern_library_components_modal_1.Modal, { type: inPanel ? "panel" : 'popup', className: modalClasses, closeButtonClass: closeButtonClass, isModalVisible: isPanelOpen, onModalClose: () => setIsPanelOpen(false), modalLabel: "promotionPanel", children: (0, jsx_runtime_1.jsx)(Content, { ...props }) })] }));
};
BannerAction.propTypes = {
    action: prop_types_1.default.string,
    actionText: prop_types_1.default.string,
    actionTextClassName: prop_types_1.default.string
};
exports.default = BannerAction;
//# sourceMappingURL=BannerAction.js.map